import { IconWrapper } from '../runtime';
export default IconWrapper('document', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M10.25 5.99966H5.75M13.25 5.12102V12.7497C13.25 13.5781 12.5784 14.2497 11.75 14.2497H4.25C3.42157 14.2497 2.75 13.5781 2.75 12.7497V3.24969C2.75 2.42127 3.42157 1.74969 4.25 1.74969H9.87868C10.2765 1.74969 10.658 1.90773 10.9393 2.18903L12.8107 4.06035C13.092 4.34166 13.25 4.72319 13.25 5.12102Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});